import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import InactiveMember from './inactive-member';

class InactiveMemberList extends React.Component {
  static propTypes = {
    users: PropTypes.array.isRequired
  }

  render() {
    const { users } = this.props;

    const members = users.map((user) => (
      <InactiveMember
        key={user.swicus_id}
        swicus_id={user.swicus_id}
        email={user.email}
        name={[user.first_name, user.last_name].join(" ")}
        timezone={user.timezone}
      />
    ));

    if (users.length) {
      return (
        <ul className="list classy">
          {members}
        </ul>
      );
    } else {
      return <p>There are no inactive users at this time.</p>;
    }
  }
};

$(function() {
  ReactDOM.render(
    <InactiveMemberList
      users={PT.inactiveMembers}
    />,
    document.getElementById('inactive-members-ui')
  );
});
